import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import * as Sentry from "@sentry/react";

interface Window {
  [key: string]: any;
}
declare var window: Window;

import "./index.css";
import App from "./App.tsx";

const environment = import.meta.env.MODE;

if (environment === "production") {
  // Initialize Sentry for error tracking in production
  Sentry.init({
    dsn: `${import.meta.env.VITE_SENTRY_DSN}`,
  });

  // Add GTM tracking code
  // const gtmId = import.meta.env.VITE_GTM_ID;
  // if (gtmId) {
  //   (function (w, d, s, l, i) {
  //     w[l] = w[l] || [];
  //     w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"});
  //     const f = d.getElementsByTagName(s)[0];
  //     const j = d.createElement(s) as HTMLScriptElement;
  //     const dl = l !== "dataLayer" ? "&l=" + l : "";
  //     j.async = true;
  //     j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
  //     f.parentNode?.insertBefore(j, f);
  //   })(window, document, "script", "dataLayer", gtmId);
  // }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
